module.exports = __webpack_public_path__ + "img/cpf-loading.80dd28bf.gif";